import FamilyIcon from '@mui/icons-material/Diversity1TwoTone'
import './AppTitle.css'

const AppTitle = () => {
    return (
        <div className="logo-section">
            <div className="summoning-section">Summoning</div>
            <div className="match-maker-section">
                <div className="text">Match</div>
                <FamilyIcon className="icon" color="error" />
                <div className="text">Maker</div>
            </div>
        </div>
    )
}

export default AppTitle
